import React from 'react';
import { LabelInput } from '../../../atoms/Inputs/LabelInput';
import { addProfFormErrorHandling } from '../../../../helpers/forms/formsErrorHandling/addProfFormErrorHandling';

export const ProfFields = ({ setForm, profForm }) => {
  return (
    <div>
      <LabelInput
        label="Prénom"
        name="firstname"
        placeHolder="Phillipe"
        onChange={e =>
          setForm(
            addProfFormErrorHandling(
              profForm,
              'firstname',
              e && e.target && e.target.value
            )
          )
        }
        value={profForm.values.firstname || ''}
        error={profForm.errors && profForm.errors.firstname}
      />
      <LabelInput
        label="Nom de famille"
        name="lastname"
        placeHolder="Dubois"
        onChange={e =>
          setForm(
            addProfFormErrorHandling(
              profForm,
              'lastname',
              e && e.target && e.target.value
            )
          )
        }
        value={profForm.values.lastname || ''}
        error={profForm.errors && profForm.errors.lastname}
      />
      <LabelInput
        label="Email"
        name="email"
        placeHolder="phill.dubois@gmail.com"
        onChange={e =>
          setForm(
            addProfFormErrorHandling(
              profForm,
              'email',
              e && e.target && e.target.value
            )
          )
        }
        value={profForm.values.email || ''}
        error={profForm.errors && profForm.errors.email}
      />
      <LabelInput
        label="Téléphone"
        name="tel"
        placeHolder="0790670909"
        onChange={e =>
          setForm(
            addProfFormErrorHandling(
              profForm,
              'tel',
              e && e.target && e.target.value
            )
          )
        }
        value={profForm.values.tel || ''}
        error={profForm.errors && profForm.errors.tel}
      />
    </div>
  );
};
